<form [formGroup]="requestListSubHeaderForm">
  <div class="expanded-row-filter">
    <div *ngFor="let col of filteredRequest; let i = index;" class="alignClass"
         [ngClass]="{'expanded-row-item': true,'ext-env-row' : (col.header === 'Source' && isHidden), 'sdps-hide' : (col.header === '407 Liable' && isHidden)}">
      <div class="er-item-header" title="{{col.header}}" [ngClass]="{'sdps-p-bottom_small': i<6}">
        <span id="requestList_{{col.header}}" *ngIf="!isHidden && onFilterClicked && col.header === '407 Liable' && (businessRbs === 'DBS' || this.accessForDbsClientOnly || (businessRbs === '' && !this.accessForRbsClientOnly && !this.accessToSPSClientOnly && !this.accessForRbsAndSpsClientOnly)) ">
          {{col.header}}
        </span>
        <span *ngIf="onFilterClicked && col.header !== '407 Liable'">
          {{col.header}}
        </span>
      </div>

      <div [ngClass]="{'er-min-height': i<6 && onFilterClicked}">
        <div class="timePickerForm" *ngIf="!isHidden && onFilterClicked && col.enum === 'dropdown' && col.field ==='liable407' && (businessRbs === 'DBS' || accessForDbsClientOnly || (businessRbs === ''  && !this.accessForRbsClientOnly && !this.accessToSPSClientOnly && !this.accessForRbsAndSpsClientOnly))">
          <label class="sr-only" [for]="'requestList_' + col.field + '_input'">{{ col.header }} filter</label>
          <p-select id="requestList_{{col.field}}" [attr.aria-label]="col.header + ' filter'" [ariaLabel]="col.header + ' filter'" [inputId]="'requestList_' + col.field + '_input'" [options]="getAdlConst.liableData" placeholder=" " formControlName="{{col.field}}"
                      class="editableTimepicker request-list-header-dropdown liable-drpdwn"
                      optionLabel="label" [disabled]="disableForm === 'disable'">
          </p-select>
        </div>

        <div *ngIf="onFilterClicked && col.header === 'Submitted Date' && col.enum === 'calendar'" class="requestlist-calendar">
          <ems-date-range-filter #range [disableForm]="disableForm === 'disable'" [selectFuturedates]="false"
                                 (submittedDate)="getSelectedDate($event);" [limitCustomRangeTo6Months]="true">
          </ems-date-range-filter>
        </div>

        <div *ngIf="onFilterClicked && col.enum === 'multiselect' && col.field ==='source'"
             class="emtr-dropdown dropDownPanel timePickerForm request-list-filter request-list-multiselect-font-size request-list-filter-multi-dropdown">
          <label class="sr-only" [for]="'requestList_' + col.field + '_input'">{{ col.header }} filter</label>
          <p-multiSelect id="requestList_{{col.field}}" [attr.aria-label]="col.header + ' filter'" [ariaLabel]="col.header + ' filter'" [inputId]="'requestList_' + col.field + '_input'" [panelStyle]="{'width': '200px'}" appendTo="body" [panelStyleClass]="sourceDropdownData?.length > 5 ? 'multiselect-dropdown' : ''" formControlName="{{col.field}}" [options]="sourceDropdownData"
                         [filter]="true" [defaultLabel]="' '" [displaySelectedLabel]="true"
                         [maxSelectedLabels]="1" [showHeader]="true" [ngClass]="{'p-disabled': businessRbs ==='RBS'}"
                         [filterPlaceHolder]="'All'" [filter]="true" [disabled]="disableForm === 'disable'">
          </p-multiSelect>
        </div>
      </div>
    </div>
  </div>
</form>
